import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { BADGES } from '../../utils';
import I18nProviderWrapper from '../I18nProvider';
import { uppercase } from './styles.ve.css';
import './index.scss';

const BADGE_COLORS = {
    [BADGES.NEW]: 'pink_700',
    [BADGES.BETA]: 'blue_700',
};

const Badge = ({ type, i18n }) => {
    const color = BADGE_COLORS[type];

    if (!color) {
        return null;
    }

    return (
        <Container
            as="span"
            className={classnames(uppercase, 'categories-badge')}
            display="inlineFlex"
            alignItems="center"
            justifyContent="center"
            height="17px"
            paddingX="1.5"
            borderWidth="sm"
            borderStyle="solid"
            borderColor={color}
            borderRadius="circle"
            backgroundColor="white"
            color={color}
            fontSize="b_xxs"
            lineHeight="b_xxs"
            fontWeight="bold"
        >
            {i18n.t(`categories_menu.badges.${type}`)}
        </Container>
    );
};

Badge.propTypes = {
    type: PropTypes.string,
    i18n: PropTypes.object,
};

export default I18nProviderWrapper(Badge);
export { Badge };
